export const budgetsReducer = (state = { loading: true, resultbudget: null, budgets: null, initialBalance: null, budget: null, numbudget: null, duplicatedbudget: null, total: 0 }, action) => {
    switch (action.type) {
        case 'BUDGET_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                budgets: action.payload.budgets,
                total: action.payload.total
            }
        case 'BUDGET_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                budget: action.payload
            }
        case 'BUDGET_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                budgets: [...state.budgets, action.payload.budget],
                resultbudget: action.payload.message
            }
        case 'NUM_BUDGET_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                numbudget: action.payload
            }
        case 'BUDGET_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                resultbudget: action.payload.message,
                budgets: state.budgets.map(budget =>
                    budget._id === action.payload.budget._id
                        ? action.payload.budget
                        : budget
                )
            }
        case 'BUDGET_DUPLICATE_SUCCESS':
            return {
                ...state,
                loading: false,
                budgets: [...state.budgets, action.payload.budget],
                resultbudget: action.payload.message,
            }
        case 'BUDGET_REMOVE_RESULT':
            return {
                ...state,
                loading: false,
                resultbudget: action.payload.message,
                budgets: state.budgets.filter(budgets => budgets._id !== action.payload.budget)
            }
        case 'BUDGET_GET_NEXT_NUMBER_SUCCESS':
            return {
                ...state,
                loading: false,
                numbudget: action.payload.next
            }
        case 'BUDGET_RESET_RESULT':
            return {
                ...state,
                resultbudget: null
            }
        case 'BUDGET_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'BUDGET_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case "BUDGET_UPDATE_ALL_AMPLIATIONS_SUCCESS":
            return {
                ...state,
                loading: false,
                resultbudget: action.payload.message,
                budgets: state.budgets.map(budget =>
                    budget._id === action.payload.budget._id
                        ? action.payload.budget
                        : budget
                )
            }
        case "BUDGET_CONVERT_TO_WO_SUCCESS":
            return {
                ...state,
                loading: false,
                resultbudget: action.payload.message
            }
        case 'BUDGETS_RESET':
            return {
                ...state,
                budgets: null
            }
        default:
            return state
    }
}